import { Modal as ModalB } from 'react-bootstrap';

function Modal({ isOpen, onClose, children }) {
  return (
    <ModalB show={isOpen} onHide={onClose}>
      <div>
        {children}
      </div>
    </ModalB>
  )
}

export default Modal;
